<!-- User Menu -->
<div class="relative">
  <button 
    z-button
    class="flex items-center pl-1 gap-4" 
    zType="outline"
    z-menu
    zTrigger="click"
    [zMenuTriggerFor]="userMenu"
  >
    <z-avatar
      [zImage]="{ fallback: getInitials(username) }"
      zSize="xs"
      zShape="rounded"
      zType="default"
    ></z-avatar>
    <span>{{username}}</span>
  </button>

  <ng-template #userMenu class="top-4">
    <div z-menu-content class="w-fit">
      <!-- User Info (Mobile only) -->
      <div class="flex items-center gap-3 px-3 py-2 border-b border-gray-200 sm:hidden">
        <mat-icon
          class="text-gray-600 h-8 w-8"
          [svgIcon]="'heroicons_outline:user-circle'"
        ></mat-icon>
        <span class="text-sm font-medium text-foreground">{{username}}</span>
      </div>

      <!-- Settings -->
      <button z-menu-item zType="outline" (click)="goToSettings()">
        <mat-icon class="h-4 w-4 mr-2" [svgIcon]="'heroicons_outline:cog-6-tooth'"></mat-icon>
        {{ 'navigation.user.settings' | transloco }}
      </button>

      <!-- Reset Password -->
      <button z-menu-item (click)="goResetPassword()">
        <mat-icon class="h-4 w-4 mr-2" [svgIcon]="'heroicons_outline:key'"></mat-icon>
        {{ 'navigation.user.reset-psw' | transloco }}
      </button>

      <!-- Language Selection -->
      <button z-menu-item z-menu zTrigger="click" [zMenuTriggerFor]="languageSubmenu" class="justify-between">
        <div class="flex items-center">
          <mat-icon class="h-4 w-4 mr-4" [svgIcon]="'heroicons_outline:language'"></mat-icon>
          {{ 'navigation.user.languages' | transloco }}
        </div>
        <div class="flex items-center gap-2">
          <span class="text-sm text-secondary-foreground">{{langName}}</span>
          <img
            class="h-4 w-4 rounded-full"
            [src]="'images/flags/' + flagCodes[activeLang].toUpperCase() + '.svg'"
          />
        </div>
      </button>
      <z-divider zSpacing="sm"></z-divider>

      <!-- Sign Out -->
      <button z-menu-item (click)="signOut()" class="text-destructive hover:text-destructive/90">
        <mat-icon class="h-4 w-4 mr-2" [svgIcon]="'heroicons_outline:arrow-right-on-rectangle'"></mat-icon>
        {{ 'navigation.user.sign-out' | transloco }}
      </button>
    </div>
  </ng-template>

  <ng-template #languageSubmenu>
    <div z-menu-content class="w-56" menuPosition="below">
      @for (lang of availableLangs; track trackByFn($index, lang)) {
        <button z-menu-item (click)="setActiveLang(lang.id, lang.label)" [class.text-blue-600]="activeLang === lang.id">
          <img
            class="h-4 w-4 rounded-full mr-2"
            [src]="'images/flags/' + flagCodes[lang.id].toUpperCase() + '.svg'"
          />
          {{ lang.label }}
          @if (activeLang === lang.id) {
            <mat-icon class="h-4 w-4 ml-auto text-blue-600" [svgIcon]="'heroicons_outline:check'"></mat-icon>
          }
        </button>
      }
    </div>
  </ng-template>
</div>
